import { motion } from "framer-motion";

const line = {
  initial: { y: "110%" },
  animate: (i) => ({
    y: "0%",
    transition: { duration: 1.1, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

function Line({ children, i = 0, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        variants={line}
        custom={i}
        initial="initial"
        animate="animate"
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-ink-950 flex items-center"
    >
      {/* Ambient blue radial */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute -top-40 -left-20 w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,_rgba(107,138,255,0.18),_transparent_65%)] blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,_rgba(43,63,138,0.35),_transparent_65%)] blur-3xl" />
      </div>

      {/* Subtle grid */}
      <div
        className="absolute inset-0 z-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #6B8AFF 1px, transparent 1px), linear-gradient(to bottom, #6B8AFF 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          maskImage: "radial-gradient(ellipse at center, black 40%, transparent 80%)",
        }}
      />

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-12 w-full pt-32 pb-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="mb-10"
        >
          <img
            src="/triad-logo.png"
            alt="Triad Marketing"
            data-testid="hero-logo"
            className="w-40 h-auto md:w-52 object-contain"
            style={{
              filter: "drop-shadow(0 0 30px rgba(107, 138, 255, 0.5)) drop-shadow(0 0 80px rgba(10, 77, 255, 0.35))",
            }}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1, duration: 0.8 }}
          className="text-[10px] uppercase tracking-[0.35em] text-blue-soft/70 flex items-center gap-4 mb-10"
        >
          <span className="w-8 h-px bg-blue" />
          Triad Marketing
        </motion.div>

        <h1 className="font-serif font-light tracking-tight leading-[0.92] text-white text-[13vw] md:text-[8vw] lg:text-[7.2vw]">
          <Line i={0}>Serviços de</Line>
          <Line i={1} className="italic" >
            <span className="text-blue">gestão</span> de perfil.
          </Line>
        </h1>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-6 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.4, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-6"
          >
            <p className="text-white/70 text-base md:text-lg leading-relaxed font-light max-w-xl">
              Tráfego pago, reels, social media, design e consultoria — pacotes desenhados para marcas que querem crescer com estratégia.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.6, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-4 md:col-start-9 flex md:justify-end"
          >
            <a
              href="#servicos"
              data-testid="hero-see-services"
              className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.28em] text-white hover:text-blue transition-colors"
            >
              Ver serviços
              <span className="w-10 h-px bg-blue transition-all duration-500 group-hover:w-16" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
